import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import { login } from "../actions/auth";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = () => {
  let navigate = useNavigate();

  const form = useRef();
  const checkBtn = useRef();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);

  const dispatch = useDispatch();

  const onChangeUsername = (e) => setUsername(e.target.value);
  const onChangePassword = (e) => setPassword(e.target.value);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch(login(username, password))
        .then(() => {
          navigate("/dashboard");
          window.location.reload();
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  if (isLoggedIn) {
    return <Navigate to="/profile" />;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage:
          "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/logo.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <div style={{ width: "100%", maxWidth: "400px" }}>
        <div
          className="card card-container"
          style={{
            backgroundColor: "rgba(0, 18, 46, 0.85)",
            color: "#fff",
            borderRadius: "16px",
            backdropFilter: "blur(10px)",
            padding: "30px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.5)"
          }}
        >
          {/* LOGO */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/logo.jpg"
              alt="logo"
              style={{
                width: "65px",
                borderRadius: "50%",
                boxShadow: "0 0 10px rgba(255,255,255,0.2)"
              }}
            />
          </div>

          <h4
            style={{
              textAlign: "center",
              marginBottom: "20px",
              fontWeight: "600",
              letterSpacing: "1px"
            }}
          >
            Login
          </h4>

          <Form onSubmit={handleLogin} ref={form}>

            {/* USERNAME */}
            <div className="form-group" style={{ marginBottom: "15px" }}>
              <div style={{ width: "260px", margin: "0 auto" }}>
                <label style={{
                  color: "#90caf9",
                  fontSize: "0.85rem",
                  display: "block"
                }}>
                  Username
                </label>

                <div style={{ position: "relative" }}>
                  <span style={{
                    position: "absolute",
                    left: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#90caf9"
                  }}>
                    👤
                  </span>

                  <Input
                    type="text"
                    className="form-control"
                    name="username"
                    value={username}
                    onChange={onChangeUsername}
                    validations={[required]}
                    style={{
                      padding: "7px 10px 7px 28px",
                      fontSize: "0.9rem",
                      borderRadius: "8px",
                      backgroundColor: "#001B44",
                      color: "#fff",
                      border: "1px solid #3949ab"
                    }}
                  />
                </div>
              </div>
            </div>

            {/* PASSWORD */}
            <div className="form-group" style={{ marginBottom: "20px" }}>
              <div style={{ width: "260px", margin: "0 auto" }}>
                <label style={{
                  color: "#90caf9",
                  fontSize: "0.85rem",
                  display: "block"
                }}>
                  Password
                </label>

                <div style={{ position: "relative" }}>
                  <span style={{
                    position: "absolute",
                    left: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#90caf9"
                  }}>
                    🔒
                  </span>

                  <Input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    name="password"
                    value={password}
                    onChange={onChangePassword}
                    validations={[required]}
                    style={{
                      padding: "7px 30px 7px 28px",
                      fontSize: "0.9rem",
                      borderRadius: "8px",
                      backgroundColor: "#001B44",
                      color: "#fff",
                      border: "1px solid #3949ab"
                    }}
                  />

                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#90caf9"
                    }}
                  >
                    {showPassword ? "🙈" : "👁"}
                  </span>
                </div>
              </div>
            </div>

            {/* BUTTON */}
            <div className="form-group" style={{ textAlign: "center" }}>
              <button
                disabled={loading}
                style={{
                  padding: "7px 28px",
                  borderRadius: "8px",
                  fontSize: "0.9rem",
                  backgroundColor: "#3949ab",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  transition: "0.2s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#5c6bc0"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#3949ab"}
              >
                {loading ? "Loading..." : "Login"}
              </button>
            </div>

            {/* ERROR */}
            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}

            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;